module.exports = "/assets/fdf2ef6dbd335d7ff87ff3d1a11bbe10.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3S.png
// module id = 1019
// module chunks = 0